var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye-slash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.00195 2L14.002 14M6.56481 6.6091C6.21638 6.96903 6.00195 7.45948 6.00195 8C6.00195 9.10457 6.89738 10 8.00195 10C8.55027 10 9.04705 9.77935 9.40835 9.42199M4.33529 4.43143C3.06908 5.26689 2.10464 6.52263 1.64062 7.99998C2.49013 10.7047 5.01699 12.6667 8.0021 12.6667C9.32802 12.6667 10.5635 12.2796 11.6018 11.6123M7.33529 3.36626C7.5546 3.34448 7.77704 3.33333 8.00208 3.33333C10.9872 3.33333 13.5141 5.29528 14.3636 8.00002C14.1764 8.59598 13.9078 9.15588 13.5707 9.66667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClosed);
export default __webpack_public_path__ + "static/media/eyeClosed.e39f66265656a209191e83cd05517d3a.svg";
export { ForwardRef as ReactComponent };